module.exports = __webpack_public_path__ + "0cec3577260fddfe2f892a523d687119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-ctc.png
// module id = 1274
// module chunks = 0